import ALink from '../components/common/ALink';
import Image from 'next/image';
import { useAxios } from '../hooks/useAxios/useAxios';
import { toast } from 'react-toastify';
import MetaHeader from '../components/common/MetaHeader';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { contactUsSchema } from '../utils/validation/contact-us-schema';
import { useRef } from 'react';

export default function ContactUs() {
  const { execute: sendContactInfo, isLoading } = useAxios(
    '/public/buyontrust/send_contact_form',
    { method: 'post' },
    false,
    data => {
      console.log(data);
      if (data) {
        if (data.success) {
          toast.success('Your message has been successfully sent');
        } else {
          console.log('lol', data);
          toast.error(data.message);
        }
      }
    }
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(contactUsSchema)
  });

  const onSubmit = async data => {
    const formattedData = {
      'contact-name': data.contact_name,
      'contact-email': data.contact_email,
      'contact-subject': data.contact_subject,
      'contact-message': data.contact_message
    };

    await sendContactInfo(formattedData);
    reset();
  };

  return (
    <>
      <MetaHeader title={'Contact us'} />
      <main className="main contact-two">
        <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <ALink href="/">Home</ALink>
              </li>
              <li className="breadcrumb-item">
                <ALink href="#">Pages</ALink>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Contact Us
              </li>
            </ol>
          </div>
        </nav>

        <div className="container">
          <div className="row ">
            <div className="col-md-6">
              <div className="ls-n-10 mb-1 pb-2">
                <h1 className="subpage__title">Contact Us</h1>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group required-field">
                      <label htmlFor="contact-name">Your name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="contact-name"
                        name="contact_name"
                        maxLength={30}
                        {...register('contact_name')}
                      />
                      {errors.contact_name && (
                        <p className={'text-danger'}>
                          {errors.contact_name.message}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group required-field">
                      <label htmlFor="contact-email">Your email address</label>
                      <input
                        type="email"
                        className="form-control"
                        id="contact-email"
                        name="contact_email"
                        maxLength={40}
                        {...register('contact_email')}
                      />
                      {errors.contact_email && (
                        <p className={'text-danger'}>
                          {errors.contact_email.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="contact-subject">Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    id="contact-subject"
                    name="contact_subject"
                    maxLength={80}
                    {...register('contact_subject')}
                  />
                  {errors.contact_subject && (
                    <p className={'text-danger'}>
                      {errors.contact_subject.message}
                    </p>
                  )}
                </div>

                <div className="form-group required-field mb-0">
                  <label htmlFor="contact-message">Your Message</label>
                  <textarea
                    style={{ fontSize: '1.4rem' }}
                    cols="30"
                    rows="1"
                    id="contact-message"
                    className="form-control"
                    name="contact_message"
                    maxLength={2000}
                    {...register('contact_message')}></textarea>
                  {errors.contact_message && (
                    <p className={'text-danger'}>
                      {errors.contact_message.message}
                    </p>
                  )}
                </div>

                <div className="form-footer">
                  <button
                    disabled={isLoading}
                    type="submit"
                    className="btn w-25 w-sm-100 p-4 btn-dark mr-0 btn-md">
                    Send Message
                  </button>
                </div>
              </form>
            </div>

            <div className="col-md-6">
              <h2 className="contact-title">
                <strong>Have any additional questions?</strong>
              </h2>
              <p>
                Chat live with us or leave an after-hours message and we will
                get back to you the next business day. You can also send us an
                email at
                <a
                  href="mailto:info@buyontrust.com"
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                  info@buyontrust.com
                </a>
                .
              </p>
              <p>
                We can also be reached by calling
                <a
                  href="tel:+18882747732"
                  style={{
                    marginLeft: '4px',
                    marginRight: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600',
                    textDecoration: 'underline'
                  }}>
                  888-274-7732
                </a>
                during normal business hours.
              </p>

              <hr className="mt-3 mb-0" />

              <div className="contact-info mb-2">
                <h2 className="contact-title">
                  <strong>The Office</strong>
                </h2>

                <div className="d-flex align-items-center">
                  <Image
                    src={'/images/map-marker-icon.svg'}
                    alt='Address'
                    width={28}
                    height={28}
                  />
                  <h3 className="contacts-subtitle">
                    <strong>Address:</strong> 1434 Spruce St, Suite 100,
                    Boulder, CO 80302
                  </h3>
                </div>
                <div className="d-flex align-items-center">
                  <Image
                    src={'/images/phone-icon.svg'}
                    alt='Phone'
                    width={28}
                    height={28}
                  />
                  <a href="tel:+18882747732">
                    <h3 className="contacts-subtitle">
                      <strong>Phone:</strong> (888)-274-7732
                    </h3>
                  </a>
                </div>
                <div className="d-flex align-items-center">
                  <Image
                    src={'/images/envelope-icon.svg'}
                    alt='Email'
                    width={28}
                    height={28}
                  />

                  <h3 className="contacts-subtitle">
                    <strong>Email:</strong> info@buyontrust.com
                  </h3>
                </div>
              </div>

              <hr className="mt-1 mb-0" />

              <div className="contact-time">
                <h2 className="contact-title">
                  <strong>Business Hours</strong>
                </h2>

                <div className="d-flex align-items-center">
                  <Image
                    src={'/images/clock-icon.svg'}
                    alt='Clock'
                    width={16}
                    height={16}
                  />
                  <h3 className="contacts-subtitle">
                    Monday - Friday 9am to 5pm
                  </h3>
                </div>

                <div className="d-flex align-items-center mt-2">
                  <Image
                    src={'/images/clock-icon.svg'}
                    alt='Clock'
                    width={16}
                    height={16}
                  />
                  <h3 className="contacts-subtitle">Saturday - 9am to 2pm</h3>
                </div>

                <div className="d-flex align-items-center mt-2">
                  <Image
                    src={'/images/clock-icon.svg'}
                    alt='Clock'
                    width={16}
                    height={16}
                  />
                  <h3 className="contacts-subtitle">Sunday - Closed</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
